import { IViewPortionContext } from './viewPortionContext';

export enum ViewPortionActionTypes {
	SET_DATA = 'SET_DATA',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
}

interface ISetData {
	type: ViewPortionActionTypes.SET_DATA;
	payload: {
		portionFullInfo: IViewPortionContext['portionFullInfo'];
	};
}

interface ISetTranslationTab {
	type: ViewPortionActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IViewPortionContext['selectedTranslationTab'];
	};
}

export type TViewPortionAction = ISetData | ISetTranslationTab;
